import styled from "styled-components";

export const Form = styled.form`
	display: flex;
	gap: 12px;
	align-items: center;
`;

export const FormColumn = styled.div`
	flex: 1;
`;

export const AIForm = styled.form`
	display: flex;
	gap: 12px;
	height: 400px;
`;

export const AIFormColumn = styled.div`
	flex: 1;
	align-items: flex-start;
	justify-content: flex-start;
`;
